import { render, staticRenderFns } from "./quesCheckbox.vue?vue&type=template&id=248dee28"
import script from "./quesCheckbox.vue?vue&type=script&lang=js"
export * from "./quesCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports